<p-table [value]="allPackBoxes" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th style="max-width: 3rem"></th>
            <th>Name</th>
            <th>Is Active</th>
            <th>Is Default</th>
            <th>Length (in)</th>
            <th>Width (in)</th>
            <th>Height(in)</th>
            <th>Weight(lbs)</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
        <tr class="parentRow">
            <td class="action">
                <button
                    type="button"
                    [pRowToggler]="product"
                    pButton
                    pRipple
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="
                        expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                    "
                    *ngIf="product.childPackBoxes.length > 0"
                    style="width: 20px; height: 20px"
                ></button>
            </td>
            <td>{{ product.name }}</td>
            <td>{{ product.statusId == "1" ? "Yes" : "No" }}</td>
            <td>
                <p-radioButton
                    [disabled]="product.statusId != '1' || product.isDefault"
                    [value]="true"
                    [(ngModel)]="product.isDefault"
                    (onClick)="boxDefault(product)"
                ></p-radioButton>
                {{ product.isDefault ? "Yes" : "No" }}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="action">
                <span
                    class="btnBars p-mr-0"
                    pTooltip="Add"
                    tooltipPosition="top"
                    (click)="addChild(product)"
                >
                    <i class="pi pi-plus"></i
                ></span>
                <span
                    class="btnBars p-mr-0"
                    pTooltip="Edit"
                    tooltipPosition="top"
                    (click)="editParent(product)"
                >
                    <i class="pi pi-pencil"></i
                ></span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
        <ng-container *ngFor="let child of product?.childPackBoxes">
            <tr>
                <td></td>
                <td style="padding-left: 2rem !important">{{ child.name }}</td>
                <td>{{ child.statusId == "1" ? "Yes" : "No" }}</td>
                <td>
                    <p-radioButton
                        [disabled]="
                            product.statusId != '1' ||
                            child.statusId != '1' ||
                            !product.isDefault
                        "
                        [value]="true"
                        [(ngModel)]="child.isDefault"
                        (onClick)="boxDefault(child)"
                    ></p-radioButton>
                    {{ child.isDefault ? "Yes" : "No" }}
                </td>
                <td>{{ child.length }}</td>
                <td>{{ child.width }}</td>
                <td>{{ child.height }}</td>
                <td>{{ child.weight }}</td>
                <td class="action">
                    <span
                        class="btnBars p-mr-0"
                        pTooltip="Edit"
                        (click)="editChild(product, child)"
                        tooltipPosition="top"
                        ><i class="pi pi-pencil"></i
                    ></span>
                    <span
                        class="btnBars p-mr-0"
                        pTooltip="Remove"
                        (click)="removeChild(product, child)"
                        *ngIf="!child.isDefault"
                        tooltipPosition="top"
                        ><i class="pi pi-trash"></i
                    ></span>
                </td>
            </tr>
        </ng-container>
    </ng-template>
</p-table>

<p-dialog
    header="{{ addEditParentHeader }}"
    [modal]="true"
    [(visible)]="displayAddEditParent"
    [style]="{ width: '50vw' }"
>
    <form [formGroup]="parentForm">
        <div class="header">
            <h5>
                Package
                <p-inputSwitch
                    class="header-switch"
                    pTooltip="is Active"
                    tooltipPosition="top"
                    formControlName="statusId"
                ></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="name"
                        >Name <span style="color: red">*</span></label
                    >
                    <input type="text" (focus)="isDuplicacy = false" pInputText formControlName="name" />
                    <small *ngIf="isDuplicacy" class="p-invalid">Name already exists.</small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button
            pButton (click)="onCancel()"
            label="Cancel"
            class="p-button-secondary"
        ></button>
        <button
            pButton
            label="Save"
            [disabled]="!parentForm.valid || submittedParent"
            (click)="saveParent()"
        ></button>
    </ng-template>
</p-dialog>

<p-dialog
    header="{{ addEditChildHeader }}"
    [modal]="true"
    [(visible)]="displayAddEditChild"
    [style]="{ width: '50vw' }"
>
    <form [formGroup]="childForm">
        <div class="header">
            <h5>
                Box
                <p-inputSwitch
                    class="header-switch"
                    pTooltip="is Active"
                    tooltipPosition="top"
                    formControlName="statusId"
                ></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="name"
                        >Name <span style="color: red">*</span></label
                    >
                    <input type="text" pInputText formControlName="name" />
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4">
                    <label>Length</label>
                    <input
                        type="text"
                        pInputText
                        formControlName="length"
                        appNumbersOnly
                    />
                </div>
                <div class="p-col-4">
                    <label>Width</label>
                    <input
                        type="text"
                        pInputText
                        formControlName="width"
                        appNumbersOnly
                    />
                </div>
                <div class="p-col-4">
                    <label>Height</label>
                    <input
                        type="text"
                        pInputText
                        formControlName="height"
                        appNumbersOnly
                    />
                </div>
                <div class="p-col-4">
                    <label>Weight</label>
                    <input
                        type="text"
                        pInputText
                        formControlName="weight"
                        appNumbersOnly
                    />
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button
            pButton
            (click)="displayAddEditChild = false"
            label="Cancel"
            class="p-button-secondary"
        ></button>
        <button
            pButton
            label="Save"
            [disabled]="!childForm.valid || submittedChild"
            (click)="saveChild()"
        ></button>
    </ng-template>
</p-dialog>
